import Tooltip, { TooltipProps } from '@atlaskit/tooltip';
import React from 'react';

import { EllipsisTooltipTag } from './EllipsisTooltipTag';

type Props = {
  content?: string | null;
  children?: React.ReactNode;
  position?: TooltipProps['position'];
  mousePosition?: TooltipProps['mousePosition'];
};

export const EllipsisTooltip = ({ content, children, position = 'mouse', mousePosition = 'bottom' }: Props) => {
  return (
    <Tooltip delay={500} content={content} tag={EllipsisTooltipTag} position={position} mousePosition={mousePosition}>
      {children}
    </Tooltip>
  );
};
